import { render, staticRenderFns } from "./OneCard.vue?vue&type=template&id=74dd8198"
import script from "./OneCard.vue?vue&type=script&lang=js"
export * from "./OneCard.vue?vue&type=script&lang=js"
import style0 from "../../shared/sass/saved-cards/one-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports